module.exports = __webpack_public_path__ + "img/p15.ce50aebd.png";